import type React from 'react'

import { EmailInput } from '../EmailInput'
import css from './styles.module.css'

interface Props {
  onInvite: (email: string) => void
}

export const InviteCard: React.FC<Props> = ({ onInvite }) => {
  return (
    <>
      <div className={css.invite_card}>
        <EmailInput onSubmit={onInvite} />
      </div>

      <div className={css.invite_info}>
        This is a billable event. Each additional seat will increase your
        invoice based on your plan.
      </div>
    </>
  )
}
